import {
  faFileAudio,
  faFileImage,
  faFilePdf,
  faFileVideo,
  faPaperclip,
  faTrashXmark,
} from "@fortawesome/duotone-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Typography } from "@joonapp/web-shared"
import { JoonUIColor } from "@joonapp/web-shared"

const AttachmentItem = ({
  name,
  url,
  onRemove,
  className,
}: {
  name: string
  url: string
  onRemove?: () => void
  className?: string
}) => {
  const attachmentType = name.split(".")[1]

  const icon = getAttachmentIcon(attachmentType)

  const openImageInNewTab = () => {
    window.open(url, "_blank")
  }

  return (
    <div className={`border border-borderPrimary rounded-md ${className}`}>
      <div className="flex flex-col">
        {["png", "jpg", "jpeg", "gif"].includes(attachmentType) && (
          <div className="border-b border-borderPrimary w-full">
            <img
              src={url}
              alt={name}
              className="max-h-[120px] object-cover w-full"
            />
          </div>
        )}
        <div className="flex flex-row items-center gap-2 p-2">
          <button
            onClick={openImageInNewTab}
            className="flex flex-row gap-2 items-center hover:underline"
          >
            <FontAwesomeIcon
              icon={icon}
              fontSize={16}
              color={JoonUIColor.icon.accent}
            />
            <Typography variant="bodySmall" className="truncate">
              {name}
            </Typography>
          </button>

          {onRemove && (
            <button
              className="ml-auto"
              onClick={(e) => {
                e.preventDefault()
                onRemove()
              }}
            >
              <FontAwesomeIcon
                icon={faTrashXmark}
                fontSize={16}
                color={JoonUIColor.semantic.destructive}
              />
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default AttachmentItem

const getAttachmentIcon = (name: string) => {
  const splitName = name.split(".")
  const attachmentType = splitName[splitName.length - 1]

  if (["png", "jpg", "jpeg"].includes(attachmentType)) return faFileImage
  if (["mp4", "mov", "avi", "mkv"].includes(attachmentType)) return faFileVideo
  if (["mp3", "wav", "m4a"].includes(attachmentType)) return faFileAudio
  if (["pdf"].includes(attachmentType)) return faFilePdf
  return faPaperclip
}
